import React, { useState, useEffect } from "react";
import axios from "axios";

const GroupRequestsPage = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await axios.get(`/api/groups/requests/1`); // Remplacez `1` par l'ID du groupe
        setRequests(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Erreur lors de la récupération des demandes :", error);
        alert("Impossible de charger les demandes.");
      }
    };

    fetchRequests();
  }, []);

  const handleRequestAction = async (requestId, action) => {
    try {
      await axios.patch(`/api/groups/requests/${requestId}`, {
        status: action,
      });
      alert(
        `Demande ${action === "accepted" ? "acceptée" : "rejetée"} avec succès.`
      );
      setRequests((prev) => prev.filter((request) => request.id !== requestId));
    } catch (error) {
      console.error("Erreur lors du traitement de la demande :", error);
      alert("Impossible de traiter la demande.");
    }
  };

  if (loading) {
    return <p>Chargement...</p>;
  }

  return (
    <div className="max-w-4xl mx-auto mt-10">
      <h1 className="text-xl font-bold mb-4">Demandes de groupe</h1>
      {requests.length > 0 ? (
        <ul className="space-y-4">
          {requests.map((request) => (
            <li
              key={request.id}
              className="p-4 border rounded shadow flex justify-between items-center"
            >
              <div>
                <p>
                  {request.user.prenom} {request.user.nom}
                </p>
              </div>
              <div className="space-x-2">
                <button
                  onClick={() => handleRequestAction(request.id, "accepted")}
                  className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                >
                  Accepter
                </button>
                <button
                  onClick={() => handleRequestAction(request.id, "rejected")}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Rejeter
                </button>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p>Aucune demande en attente.</p>
      )}
    </div>
  );
};

export default GroupRequestsPage;
